import React, { useState, useEffect } from 'react';

const DS_API = 'https://api.gp-pay.net';

export default function DSLogin() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        // আগে থেকে login থাকলে redirect
        const token = localStorage.getItem('ds_token');
        const role = localStorage.getItem('ds_role');
        if (token && role === 'master') window.location.href = '/debit_security/master';
        if (token && role === 'ds_admin') window.location.href = '/debit_security/admin';
    }, []);

    const handleLogin = async (e) => {
        e.preventDefault();
        if (!username || !password) { setError('Username ও Password দাও'); return; }
        setLoading(true);
        setError('');
        try {
            const res = await fetch(`${DS_API}/debit_security/api/login`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ username, password })
            });
            const data = await res.json();
            if (data.success) {
                localStorage.setItem('ds_token', data.token);
                localStorage.setItem('ds_role', data.role);
                localStorage.setItem('ds_username', data.username);
                if (data.website_code) localStorage.setItem('ds_website_code', data.website_code);
                window.location.href = data.role === 'master' ? '/debit_security/master' : '/debit_security/admin';
            } else {
                setError(data.message || 'Login ব্যর্থ হয়েছে');
            }
        } catch {
            setError('Server এর সাথে সংযোগ হচ্ছে না');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={styles.bg}>
            <div style={styles.card}>
                <div style={styles.logo}>🔐</div>
                <h2 style={styles.title}>DebitSecurity</h2>
                <p style={styles.sub}>Reseller Management System</p>

                <form onSubmit={handleLogin} style={styles.form}>
                    <div style={styles.field}>
                        <label style={styles.label}>Username</label>
                        <input
                            style={styles.input}
                            type="text"
                            placeholder="Username লিখুন"
                            value={username}
                            onChange={e => setUsername(e.target.value)}
                            autoComplete="username"
                        />
                    </div>
                    <div style={styles.field}>
                        <label style={styles.label}>Password</label>
                        <input
                            style={styles.input}
                            type="password"
                            placeholder="Password লিখুন"
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                            autoComplete="current-password"
                        />
                    </div>

                    {error && <div style={styles.error}>{error}</div>}

                    <button style={loading ? { ...styles.btn, opacity: 0.7 } : styles.btn} type="submit" disabled={loading}>
                        {loading ? 'যাচাই হচ্ছে...' : 'Login'}
                    </button>
                </form>
            </div>
        </div>
    );
}

const styles = {
    bg: {
        minHeight: '100vh', background: '#0d1117',
        display: 'flex', alignItems: 'center', justifyContent: 'center'
    },
    card: {
        background: '#161b22', border: '1px solid #30363d', borderRadius: 12,
        padding: '40px 36px', width: 360, textAlign: 'center',
        boxShadow: '0 8px 32px rgba(0,0,0,0.4)'
    },
    logo: { fontSize: 42, marginBottom: 8 },
    title: { color: '#e6edf3', margin: '0 0 4px', fontSize: 22, fontWeight: 700 },
    sub: { color: '#8b949e', fontSize: 13, margin: '0 0 28px' },
    form: { textAlign: 'left' },
    field: { marginBottom: 16 },
    label: { display: 'block', color: '#8b949e', fontSize: 12, marginBottom: 6, fontWeight: 600 },
    input: {
        width: '100%', background: '#0d1117', border: '1px solid #30363d',
        borderRadius: 6, color: '#e6edf3', padding: '10px 12px',
        fontSize: 14, outline: 'none', boxSizing: 'border-box'
    },
    error: {
        background: '#3d1a1a', border: '1px solid #f85149', borderRadius: 6,
        color: '#f85149', fontSize: 13, padding: '10px 12px', marginBottom: 16
    },
    btn: {
        width: '100%', background: '#238636', border: 'none', borderRadius: 6,
        color: '#fff', fontSize: 15, fontWeight: 600, padding: '12px',
        cursor: 'pointer', marginTop: 4
    }
};
